import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import PostureDonut from "./PostureDonut";

interface ConfigurationProgressProps {
  posture: {
    score: Record<string, number>;
    maturity: Record<string, number>;
  };
}

const PostureChart: React.FC<ConfigurationProgressProps> = ({ posture }) => {
  const { t } = useTranslation();
  const headers = ["FNCS", "GDPR", "PSNC", "NIS2"];

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "auto repeat(4, 1fr)",
        columnGap: 2,
        rowGap: 0,
        alignItems: "center",
      }}
    >
      {/* HEADER */}
      <Box /> {/* empty top-left cell */}
      {headers.map((h) => (
        <Typography
          key={h}
          variant="subtitle1"
          sx={{ textAlign: "center", mb: 1 }}
        >
          {h}
        </Typography>
      ))}

      {/* COVERAGE */}
      <Typography variant="subtitle2" sx={{ textAlign: "right" }}>
        {t("Coverage")}
      </Typography>
      {headers.map((h) => {
        const key = h.toLowerCase();
        const val = posture.score[key] ?? 0;
        return (
          <Box
            key={`cov-${key}`}
            sx={{
              backgroundColor: (theme) => theme.palette.mode === 'dark'
                ? theme.palette.background.paper
                : "#f5f5f5",
              borderRadius: "16px 16px 0 0",
              p: 2,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <PostureDonut
              name={`cov-${key}`}
              increment={val.toString()}
              data={[
                { sector: "yes", size: val },
                { sector: "no", size: 100 - val },
              ]}
            />
          </Box>
        );
      })}

      {/* MATURITY */}
      <Typography variant="subtitle2" sx={{ textAlign: "right" }}>
        {t("Maturity")}
      </Typography>
      {headers.map((h) => {
        const key = h.toLowerCase();
        const val = posture.maturity[key] ?? 0;
        return (
          <Box
            key={`mat-${key}`}
            sx={{
              backgroundColor: (theme) => theme.palette.mode === 'dark'
                ? theme.palette.background.paper
                : "#f5f5f5",
              borderRadius: "0 0 16px 16px",
              p: 2,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <PostureDonut
              name={`mat-${key}`}
              increment={val.toString()}
              data={[
                { sector: "yes", size: val },
                { sector: "no", size: 100 - val },
              ]}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default PostureChart;
